export const CART_ADD_ITEM = 'CART_ADD_ITEM';
export const BASE_URL = process.env.NODE_ENV === 'development' ? 'https://cakes.co.ke' : 'https://cakes.co.ke';
